import { render, staticRenderFns } from "./DownloadSu.vue?vue&type=template&id=36eccced&scoped=true&"
import script from "./DownloadSu.vue?vue&type=script&lang=js&"
export * from "./DownloadSu.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSu.vue?vue&type=style&index=0&id=36eccced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eccced",
  null
  
)

export default component.exports